import React, { useCallback, useEffect, useState } from "react";
import { Accordion, AccordionDetails, AccordionSummary, Typography } from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import dataProvider from "server/dataProvider";
import SecuredComponent from "server/security/SecuredComponent";
import permissions from "app/permissions";
import { studentRequests } from "api/studentApi";
import { settings } from "app";
import { MobileListRow } from "features/MobileListRow";
import WorkedOutDialog from "./WorkedOutDialog";

const ClassesForMakeUpMobileExpanded = ({ record }) => {
  const [classData, setClassData] = useState([]);
  const [expanded, setExpanded] = useState(false);

  const loadExpanded = useCallback(async () => {
    try {
      const { data } = await dataProvider.customRequest(
        studentRequests.getMakeUpClassesForStudent(record?.studentEducationId, record.disciplineId),
        null,
        "GET",
      );
      setClassData(data || []);
    } catch (err) {
      console.error(err);
    }
  }, [record?.studentEducationId, record?.disciplineId]);

  useEffect(() => {
    if (expanded) loadExpanded();
  }, [expanded, loadExpanded]);

  return (
    <Accordion
      sx={{ width: "100%" }}
      onChange={(_, isExpanded) => setExpanded(isExpanded)}
    >
      <AccordionSummary expandIcon={<ExpandMoreIcon sx={{ color: "#4E2683" }} />}>
        <Typography sx={{ fontWeight: "bold" }}>Детайли</Typography>
      </AccordionSummary>
      <AccordionDetails sx={{ width: "100%" }}>
        {classData.classes?.map((item, idx) => (
          <div
            key={idx}
            style={settings.style.shadowBoxMobile}
          >
            <MobileListRow fields={[{ label: "Дата", value: item.classDate }]} />
            <MobileListRow fields={[{ label: "Тема", value: item.topicName }]} />
            <SecuredComponent permission={permissions.canManageMakeUps}>
              <WorkedOutDialog
                studentEducationId={record?.studentEducationId}
                classId={item.classId}
                onSuccess={loadExpanded}
              />
            </SecuredComponent>
          </div>
        ))}
      </AccordionDetails>
    </Accordion>
  );
};

export default ClassesForMakeUpMobileExpanded;
